import { heroData } from '@/mocks/comicData';

export default function Hero() {
  const { tags, h1, slogan, description, stats, ctaPrimary, ctaSecondary } = heroData;

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-2 flex-wrap mb-4">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 border border-primary-200"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-3">
              {h1}
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-heading font-medium mb-6">
              {slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              {description}
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8 flex-wrap">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <a
                href={ctaPrimary.href}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {ctaPrimary.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={ctaSecondary.href}
                className="inline-flex items-center gap-2 px-6 py-3 border border-secondary-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                {ctaSecondary.label}
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=epic%20Chinese%20manhua%20illustration%20with%20fantasy%20cultivation%20theme%2C%20powerful%20warrior%20in%20flowing%20robes%2C%20dramatic%20warm%20golden%20and%20crimson%20energy%20effects%2C%20ancient%20Chinese%20mythological%20setting%2C%20professional%20digital%20art%2C%20cinematic%20lighting%2C%20clean%20detailed%20rendering%2C%20epic%20atmosphere&width=360&height=500&seq=hero-comic-01&orientation=portrait"
                  alt="玄幻漫画主视觉"
                  className="w-full aspect-[3/4] object-cover rounded-2xl mt-6"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20action%20illustration%2C%20swordsman%20in%20dynamic%20battle%20pose%2C%20dramatic%20warm%20lighting%20with%20amber%20and%20red%20tones%2C%20intense%20combat%20scene%2C%20professional%20anime%20art%20style%2C%20clean%20lines%2C%20cinematic%20composition%2C%20powerful%20atmosphere&width=360&height=500&seq=hero-comic-02&orientation=portrait"
                  alt="日漫主视觉"
                  className="w-full aspect-[3/4] object-cover rounded-2xl"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20illustration%2C%20mysterious%20dark%20protagonist%20with%20shadow%20powers%2C%20dramatic%20composition%2C%20warm%20dark%20tones%20with%20golden%20accents%2C%20professional%20digital%20art%2C%20clean%20modern%20style%2C%20powerful%20atmosphere&width=360&height=500&seq=hero-comic-03&orientation=portrait"
                  alt="韩漫主视觉"
                  className="w-full aspect-[3/4] object-cover rounded-2xl col-span-2 max-w-[60%] mx-auto -mt-4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}